<template>
  <v-card class="mb-2">
    <v-card
      class="px-3 py-2 mb-3"
      flat
      tile
      color="light-blue lighten-3"
    >
      {{ $t('m.cost') }}
    </v-card>

    <v-card
      class="px-3 pb-2"
      flat
      tile
    >
      <v-row
        dense
        class=""
      >
        <v-col cols="6">
          <v-text-field
            dense
            hide-details
            outlined
            type="number"
            v-model="$store.state.estimating.HirePerDay"
            :label="$t('m.hirePerDay')"
            class=""
          />
        </v-col>
        <v-col cols="6">
          <v-text-field
            dense
            hide-details
            outlined
            type="number"
            :value="getRent"
            disabled
            :label="$t('m.hire')"
          />
        </v-col>
      </v-row>
      <v-row
        dense
        class=""
      >
        <v-col cols="6">
          <v-text-field
            dense
            hide-details
            outlined
            type="number"
            v-model="$store.state.estimating.HireCommPercent"
            suffix="%"
            :label="$t('m.hireCommPercent')"
          />
        </v-col>
        <v-col cols="6">
          <v-text-field
            dense
            disabled
            hide-details
            outlined
            :value="getRentAndCom"
            type="number"
          />
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="6">
          <v-text-field
            dense
            hide-details
            outlined
            type="number"
            v-model="$store.state.estimating.Demurrage"
            :label="$t('m.demurrage')"
          />
        </v-col>
        <v-col cols="6">
          <v-text-field
            dense
            hide-details
            outlined
            type="number"
            v-model="$store.state.estimating.Dispatch"
            :label="$t('m.dispatch')"
          />
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="6">
          <v-text-field
            dense
            hide-details
            outlined
            type="number"
            v-model="$store.state.estimating.ILOHC"
            :label="$t('m.ilohc')"
          />
        </v-col>
        <v-col cols="6">
          <v-text-field
            dense
            hide-details
            outlined
            type="number"
            v-model="$store.state.estimating.BallastBonus"
            :label="$t('m.ballastBonus')"
          />
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="6">
          <v-text-field
            dense
            hide-details
            outlined
            type="number"
            v-model="$store.state.estimating.OpOther"
            :label="$t('m.opOther')"
          />
        </v-col>
        <v-col cols="6">
          <v-text-field
            dense
            hide-details
            outlined
            type="number"
            v-model="$store.state.estimating.CEV"
            :label="$t('m.cev')"
          />
        </v-col>
      </v-row>

      <v-row dense>
        <v-col cols="6">
          <v-text-field
            dense
            hide-details
            outlined
            type="number"
            disabled
            :value="ttlAddComm"
            :label="$t('m.addCommRate')"
          />
        </v-col>
        <v-col cols="6">
          <v-text-field
            dense
            hide-details
            outlined
            type="number"
            disabled
            :value="ttlBrokerage"
            :label="$t('m.brokerageRate')"
          />
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="6">
          <v-text-field
            dense
            hide-details
            outlined
            type="number"
            disabled
            :value="ttlFrtTax"
            :label="$t('m.frtTaxRate')"
          />
        </v-col>
        <v-col cols="6">
          <v-text-field
            dense
            hide-details
            outlined
            type="number"
            disabled
            :value="ttlPortCharge"
            :label="$t('m.portCharge')"
          />
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="6">
          <v-text-field
            dense
            hide-details
            outlined
            type="number"
            disabled
            :value="fuelCost.totalFuelFee"
            :label="$t('m.fuelCost')"
          />
        </v-col>
        <v-col cols="6">
          <v-text-field
            dense
            disabled
            hide-details
            outlined
            type="number"
            :value="getOpExpense"
            :label="$t('m.opCost')"
          />
        </v-col>
      </v-row>
    </v-card> <!-- 列表 row -->
  </v-card>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import Utils from '@/utils/index'
import httpClient from '@/api/httpClient'
import Constant from '@/constant'

export default {
  name: 'CostPad',
  components: { },
  props: [
    'model'
  ],
  data () {
    return {

    }
  },
  created () {
    if (this.model) {
      this.resetForm()
    }
  },
  computed: {
    ...mapState({
      editFlag: state => state.estimating.editFlag,
      resetMessage: state => state.estimating.resetMessage,
      clearFlag: state => state.estimating.clearFlag
    }),

    ...mapGetters({
      ttlAddComm: 'getAddCommRateVal',
      ttlBrokerage: 'getBrokerageRateVal',
      ttlFrtTax: 'getFrtTax',
      ttlPortCharge: 'getPortCharge',
      fuelCost: 'getFuelCost',
      getRent: 'getRent',
      getRentAndCom: 'getRentAndCom',
      getOpExpense: 'getOpExpense',

      getHirePerDay: 'getHirePerDay',
      getOpProfit: 'getOpProfit',
      getTtlRevenue: 'getTtlRevenue',
      getTtlExpense: 'getTtlExpense'
    })

  },
  watch: {

  },
  methods: {
    resetForm () {

    },

    clearForm () {
    }
  }

}
</script>

<style scoped>

</style>
